/** @jsxImportSource @emotion/react */
import { Children, ReactElement } from "react";
import { Button } from "../element/Button";
import { css } from "@emotion/react";
import { MAP_TOOL_BUTTON } from "src/domains/shared/constants/mapToolButton";

export interface ControlGroupProps {
  title?: string;
  children:
    | ReactElement<typeof Button>
    | (boolean | ReactElement<typeof Button>)[];
}

const controlGroupStyle = css`
  width: fit-content;
  height: fit-content;
  background-color: ${MAP_TOOL_BUTTON.groupBackground};
  box-shadow: ${MAP_TOOL_BUTTON.groupShadow};
  border-radius: ${MAP_TOOL_BUTTON.GROUP_RADIUS_PX}px;
`;

const titleStyle = css`
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${MAP_TOOL_BUTTON.SIZE_PX}px;
  height: ${MAP_TOOL_BUTTON.GROUP_TITLE_HEIGHT_PX}px;
  font-size: ${MAP_TOOL_BUTTON.GROUP_TITLE_FONT_PX}px;
  font-weight: ${MAP_TOOL_BUTTON.GROUP_TITLE_FONT_WEIGHT};
  line-height: ${MAP_TOOL_BUTTON.GROUP_TITLE_LINE_HEIGHT};
  color: ${MAP_TOOL_BUTTON.groupTitleColor};
  letter-spacing: ${MAP_TOOL_BUTTON.GROUP_TITLE_LETTER_SPACING};
  border-bottom: 1px solid ${MAP_TOOL_BUTTON.groupTitleBorder};
`;

const buttonGroupStyle = css`
  display: flex;
  flex-direction: column;
  gap: 0;

  & > :last-child {
    border-bottom-left-radius: ${MAP_TOOL_BUTTON.GROUP_RADIUS_PX}px;
    border-bottom-right-radius: ${MAP_TOOL_BUTTON.GROUP_RADIUS_PX}px;
  }
`;

const untitledButtonGroupStyle = css`
  & > :first-child {
    border-top-left-radius: ${MAP_TOOL_BUTTON.GROUP_RADIUS_PX}px;
    border-top-right-radius: ${MAP_TOOL_BUTTON.GROUP_RADIUS_PX}px;
  }
`;

export const ControlGroup = ({ children, title }: ControlGroupProps) => {
  const onlyChildren = Children.toArray(children).filter((child) => child);

  return (
    <div css={controlGroupStyle}>
      {title && <div css={titleStyle}>{title}</div>}
      <div css={[buttonGroupStyle, !title && untitledButtonGroupStyle]}>
        {onlyChildren}
      </div>
    </div>
  );
};
